<template>
  <div id="excel-presupuestos-ejercicio">
    <template v-if="boton">
      <custom-button
        label="PRESUPUESTO"
        iconText="fa-file-excel"
        tipo="agregar"
        class="mr-2"
        :loading="exportandoPresupuesto"
        @click="generarExcelPresupuesto">
      </custom-button>
    </template>
    <template v-else>
      <v-list-item
      @click="generarExcelPresupuesto"
      link>
        <v-list-item-icon class="mx-2">
          <v-icon> mdi-file-excel </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title> Exportar Presupuesto </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <!-- <v-card>
        <v-card-title class="secondary--text">
          Exportar Presupuesto
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <template v-if="exportandoPresupuesto">
            <v-container>
              <v-row
                class="fill-height"
                align-content="center"
                justify="center"
              >
                <v-col
                  class="text-subtitle-1 text-center"
                  cols="12"
                >
                  Preparando exportación de presupuesto...
                </v-col>
                <v-col cols="6">
                  <v-progress-linear
                    color="primary"
                    indeterminate
                    rounded
                    height="6"
                  ></v-progress-linear>
                </v-col>
              </v-row>
            </v-container>
          </template>
          <template v-else>
            <ejercicio-picker
              v-model="ejercicioExportar"
              class="my-2">
            </ejercicio-picker>
          </template>
          <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            label="Exportar"
            tipo="formAceptar"
            :disabled="exportandoPresupuesto"
            :loading="exportandoPresupuesto"
            @click="generarExcelPresupuesto">
          </custom-button>
        </v-card-actions>
        </v-card-text>
        <pre>
          <small>
            {{ ejercicioExportar }}
          </small>
        </pre>
      </v-card> -->
    </template>
  </div>
</template>

<script>
import mixGenerarExceles from '@/helpers/mixGenerarExcel';
import CustomButton from '@/components/buttons/Button.vue';
// import EjercicioPicker from '@/components/inputs/EjercicioPicker.vue';

// Fila en la que inician los datos con titulos del excel
const filaTitulos = 2;
// const filaSubtitulos = filaTitulos + 1;
const filaInicioDatos = filaTitulos + 1;

export default {
  name: 'ExcelPresupuestoEjercicio',
  mixins: [mixGenerarExceles],
  props: {
    presupuestos: {
      type: Array,
      required: true,
    },
    ejercicio: {
      type: Number,
      required: true,
    },
    boton: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    CustomButton,
    // EjercicioPicker,
  },
  data() {
    return {
      exportandoPresupuesto: false,
      // ejercicioExportar: this.ejercicio,
      nombreDocumento: `PRESUPUESTO EJERCICIO ${this.ejercicio}`,
      configuracionExcel: {},
      contrato: {
        numero: '',
      },
      filaTitulos: 2,
      // Estilo del header
      estiloHeader: {
        font: {
          bold: true,
        },
        alignment: {
          horizontal: 'center',
          vertical: 'center',
        },
      },
      // Datos de los encabezados que apareceran en el excel.
      headersColumnas: [
        // {
        //   value: 'Ejercicio', nombreColumna: 'ejercicio', orden: 1,
        // },
        {
          value: 'Fondo', nombreColumna: 'fondo', orden: 1,
        },
        {
          value: 'Clave', nombreColumna: 'clave', orden: 2,
        },
        {
          value: 'Obra', nombreColumna: 'obra', orden: 3,
        },
        {
          value: 'Ppto. Autorizado', nombreColumna: 'pptoAutorizado', orden: 4,
        },
        {
          value: 'Ampliaciones', nombreColumna: 'ampliaciones', orden: 5,
        },
        {
          value: 'Reducciones', nombreColumna: 'reducciones', orden: 6,
        },
        {
          value: 'Ppto. Modificado', nombreColumna: 'pptoModificado', orden: 7,
        },
      ],
      noData: [{
        fondo: '',
        clave: '',
        obra: '',
        pptoAutorizado: '',
        ampliaciones: '',
        reducciones: '',
        pptoModificado: '',
      }],
    };
  },
  methods: {
    async generarExcelPresupuesto() {
      // this.nombreDocumento = `PRESUPUESTO EJERCICIO ${this.ejercicioExportar}`;
      this.exportandoPresupuesto = true;
      await this.mixGenerarExcel(this.crearExcelPresupuestos);
      this.exportandoPresupuesto = false;
    },
    cerrar() {
      this.$emit('cerrar');
    },
  },
  computed: {
    getHeaders() {
      const headers = this.headersColumnas
        .map((header) => header.value)
        .sort((a, b) => a.orden - b.orden);
      return headers;
    },
    getColumnas() {
      const columnas = this.headersColumnas
        .map((columna) => columna.nombreColumna)
        .sort((a, b) => a.orden - b.orden);
      return columnas;
    },
    crearDatosDocumento() {
      return [
        {
          value: `PRESUPUESTO EJERCICIO ${this.ejercicio}`,
          row: 1,
          col: 1,
          estilo: {
            font: {
              size: 14,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
            },
          },
          combinar: {
            row: 1,
            col: 7,
          },
        },
      ];
    },
    getDetalles() {
      const ppto = JSON.parse(JSON.stringify(this.presupuestos));
      const detalles = [];
      ppto.forEach((item) => {
        item.detalles.forEach((detalle) => {
          const ampliaciones = detalle.modificaciones.filter((elem) => elem.tipo === 'AMPLIACIÓN')
            .reduce((acc, elem) => acc + elem.importe, 0);
          const reducciones = detalle.modificaciones.filter((elem) => elem.tipo === 'REDUCCIÓN')
            .reduce((acc, elem) => acc + elem.importe, 0);
          const pptoModificado = ampliaciones + reducciones + detalle.importe;
          const data = {
            fondo: item.fuente.nombre,
            clave: detalle.claveObra,
            obra: detalle.obra.meta,
            pptoAutorizado: {
              value: detalle.importe,
              estilo: {
                numberFormat: '$#,##0.00',
              },
            },
            ampliaciones: {
              value: ampliaciones,
              estilo: {
                numberFormat: '$#,##0.00',
              },
            },
            reducciones: {
              value: reducciones,
              estilo: {
                numberFormat: '$#,##0.00',
              },
            },
            pptoModificado: {
              value: pptoModificado,
              estilo: {
                numberFormat: '$#,##0.00',
              },
            },
          };
          detalles.push(data);
        });
      });
      return detalles;
    },
    crearExcelPresupuestos() {
      // const expedientesExcel = this.getExpedientesParaExcel;
      const datosDocumento = this.crearDatosDocumento;
      const dataHeaders = this.getHeaders;
      // Se agregan totales para cantidad e importe a nombres de columnas.
      const nombreDeColumnas = [...this.getColumnas];
      const bodyData = this.getDetalles.length > 0 ? this.getDetalles : this.noData;
      const data = {
        excelData: {
          configuration: this.configuracionExcel,
          header: {
            filaInicio: filaTitulos,
            estilo: this.estiloHeader,
            // logos: [...this.logoDocumento],
            datosDocumento: [...datosDocumento],
            data: [...dataHeaders],
          },
          body: {
            nombreDeColumnas,
            filaInicio: filaInicioDatos,
            data: bodyData,
          },
        },
      };
      return data;
    },
  },
};
</script>

<style>
</style>
